var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.296496 2.55552C-0.34816 1.91086 0.135385 0.804736 1.04657 0.834909C2.74763 0.891239 4.98363 0.951611 6.75361 0.951611C8.5908 0.951611 11.0602 0.886568 12.8983 0.828514C13.8078 0.799786 14.2875 1.90301 13.644 2.5465L7.67285 8.51765C7.28232 8.90818 6.64916 8.90818 6.25864 8.51765L0.296496 2.55552Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.ad222235b7c38f42b9038944051e282d.svg";
export { ForwardRef as ReactComponent };